import { Localization } from "@viamap/viamap2-common";
import { Unlock } from "iconsax-react";
import { useContext, useEffect, useState } from "react";
import { ViewButtonIcon } from "src/propertyInfoTemplates/PropertyComponents";
import { LockUnlockDataLayer, MapitStateContext } from "src/states/MapitState";

export function UnlockedLayerInfoBox() {
   const { state: mapitState, dispatch: mapitStateDispatch } = useContext(MapitStateContext);
   const [unlockedLayers, setUnlockedLayers] = useState(Object.keys(mapitState.layers).filter((a) => mapitState.layers[a].unlocked));

   useEffect(() => {
      setUnlockedLayers(Object.keys(mapitState.layers).filter((a) => mapitState.layers[a].unlocked));
   }, [mapitState.layers])

   if (unlockedLayers.length === 0) {
      return <></>;
   }

   return (

      <div className="UnlockedLayerInfoBox">
         {Localization.getText("Unlocked layers:")}
         {unlockedLayers.map((layer) => {
            return (
               <div key={layer} className="unLockedLayer">
                  <div key={layer}>
                     {mapitState.layers[layer].datasetname}
                  </div>
                  <ViewButtonIcon onClick={() => {
                     mapitStateDispatch(LockUnlockDataLayer(layer as any, false));
                  }}>
                     <Unlock />
                  </ViewButtonIcon>
               </div>
            )
         })}
      </div>
   )
}